import { type ClassSessionRecord, type ClassSessionGroupWithMembershipsRecord } from '../../../../../models/types';

export enum WaitingRoom {
    ON = 'ON',
    OFF = 'OFF'
}

export enum CanJoinBeforeInstructor {
    YES = 'YES',
    NO = 'NO'
}

export enum RequireAuth {
    ON = 'ON',
    OFF = 'OFF'
}

export interface MeetingObj {
    topic: string;
    password: string;
    agenda: string;
    settings: {
        join_before_host: boolean;
        waiting_room: boolean;
        meeting_authentication: boolean;
    },
    meeting_id?: string;
}

export interface ClassData {
    class_name: string;
    class_description: string;
    class_code: string;
    timezone?: string;
    class_times?: string;
    template_id?: string;
    content_type?: string;
}

export interface AdditionalInstructors {
    email: string;
    user_name?: string;
}

export interface ClassSessionGroupPayload {
    class_session_group_uuid: string;
    schedule: any;
    config: any;
}

export interface ClassPayload {
    meeting_obj: MeetingObj;
    class_data: ClassData;
    additional_instructors?: AdditionalInstructors[];
    user_uuid?: string | null;
    class_sessions?: Partial<ClassSessionRecord>[];
    class_session_groups?: Partial<ClassSessionGroupWithMembershipsRecord>[];
}

interface ClassRecordData {
    class_code: string;
    class_name: string;
    class_description: string | null;
    school_name: string;
    timezone: string;
}

type ClassType = 'class' | 'template';

export enum ClassStatus {
    Published = 'published',
    Draft = 'draft'
}

export interface ClassRecord {
    class_code: string;
    class_description: string | null;
    class_name: string;
    class_number: string;
    class_options: {[key: string]: string};
    class_uuid: string;
    courseid: string;
    data: ClassRecordData;
    date_created: Date;
    meeting_id: string;
    random_value: number;
    school_name: string;
    settings_data: any;
    sid: number;
    status: ClassStatus;
    type: ClassType;
}

export interface ClassRecordWithInfo extends ClassRecord {
    first_name: string;
    last_name: string;
    password: string;
}

export interface TemplateRecord extends ClassRecord {}
